<template>
  <li :class="`facet  ${ facet.isActive ? 'is-active' : ''}`" @click="toggleFacet(facet)">
    <span class="mgt-spinner" v-if="facet.isLoading"></span>
    <span class="checkbox"></span>

    <span class="label">{{ facet.label }}</span>
  </li>
</template>

<script>
import {facetMixin} from "./mixins/facet-mixin";

export default {
  name: "ToggleFacet",
  mixins: [facetMixin],

  data() {
    return {
      isExclusiveFacet: true
    };
  },
}
</script>

<style lang="scss" scoped>
.facet {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
  padding: .1rem 0;
}

@media all and (min-width: 768px) {
  .facet {
    margin-bottom: .3rem;
    margin-left: 1rem;
    padding: .1rem .3rem;
  }
}

.checkbox {
  width: 1rem;
  height: 1rem;
  border: 1px solid #000;
  margin-right: .3rem;
  position: relative;
}

.checkbox:before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #000;
  width: .5em;
  height: .5em;
  opacity: 0;
  transition: all 0.3s ease-in-out;

}

.facet {
  &:hover .checkbox:before {
    opacity: .3;
  }

  &.is-active .checkbox:before {
    opacity: 1;
  }
}
</style>